import React, { useState, useEffect } from 'react';

import { updateProfile, fetchProfile } from '../../services/authService';


interface Person {
  first_name: string;
  last_name: string;
  email_id: string;
  gender: string;
  company_name: string;
  job_title: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  date_of_birth: string;
  date_of_joining: string;
  notes: string;
  is_active: boolean;
  created_by: string;
  updated_by: string;
}

interface UserLogin {
  username: string;
  password: string;
  is_active: boolean;
  created_by: string;
  updated_by: string;
}

interface ProfileProps {
  // Add any props you need to pass to the component
}

const Profile: React.FC<ProfileProps> = () => {
  const [person, setPerson] = useState<Partial<Person>>({});


  useEffect(() => {
    const fetchProfileData = async () => {
      const userId = localStorage.getItem('user_id') || '';
      await fetchProfile(userId).then((data) => {
        setPerson(data.person);
      }).catch((error) => {
        console.error('Error fetching profile:', error);
      });
    };
    fetchProfileData();
  }, []);


  const [userLogin, setUserLogin] = useState<UserLogin>({
    username: '',
    password: '',
    is_active: true,
    created_by: localStorage.getItem('user_id') || '',
    updated_by: localStorage.getItem('user_id') || ''
  });

  const [errors, setErrors] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [open, setOpen] = useState(false);

  const handleClose = (event: Event | React.SyntheticEvent<any, Event>, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');


    await updateProfile(person).then((response) => {
      setMessage('Profile Update successful!');
      setSeverity('success');
      setOpen(true);
    }).catch((error) => {
      setMessage(error.message);
      setSeverity('error');
      setOpen(true);
    });
  };

  const handlePersonChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = event.target;
    setPerson({ ...person, [name]: value });
  };

  const handleGenderChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    setPerson({ ...person, [name]: value });
  };

  const handleUserLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setUserLogin({ ...userLogin, [name]: value });
  };

  return (
    <div className='row'>
      <div className="col-xl-5 col-lg-4">
        <div className="h2">Profile</div>
        <form onSubmit={handleSubmit}>
          <section>
            <div className="h3">Personal Details</div>
            <div className='form-group'>
              <input
                id="first_name"
                name="first_name"
                placeholder="First Name"
                type="text"
                defaultValue={person.first_name}
                value={person.first_name}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="last_name"
                name="last_name"
                placeholder="Last Name"
                type="text"
                value={person.last_name}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="email_id"
                name="email_id"
                placeholder="Email ID"
                type="email"
                value={person.email_id}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <div id="demo-simple-select-autowidth-placeholder">Gender</div>
              <select
                id="demo-simple-select-autowidth"
                value={person.gender}
                onChange={handleGenderChange}
                className="form-control"
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </div>
            <div className='form-group'>
              <input
                id="company_name"
                name="company_name"
                placeholder="Company Name"
                type="text"
                value={person.company_name}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="job_title"
                name="job_title"
                placeholder="Job Title"
                type="text"
                value={person.job_title}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="phone"
                name="phone"
                placeholder="Phone"
                type="text"
                value={person.phone}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="address"
                name="address"
                placeholder="Address"
                type="text"
                value={person.address}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="city"
                name="city"
                placeholder="City"
                type="text"
                value={person.city}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="state"
                name="state"
                placeholder="State"
                type="text"
                value={person.state}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="zip_code"
                name="zip_code"
                placeholder="Zip Code"
                type="text"
                value={person.zip_code}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="country"
                name="country"
                placeholder="Country"
                type="text"
                value={person.country}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="date_of_birth"
                name="date_of_birth"
                placeholder="Date of Birth"
                type="date"
                value={person.date_of_birth}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="date_of_joining"
                name="date_of_joining"
                placeholder="Date of Joining"
                type="date"
                value={person.date_of_joining}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
            <div className='form-group'>
              <input
                id="notes"
                name="notes"
                placeholder="Notes"
                value={person.notes}
                onChange={handlePersonChange}
                className="form-control"
              />
            </div>
          </section>

          <button type="submit" className="btn btn-primary" style={{ marginTop: "16px" }}>
            Update
          </button>
        </form>
      </div>
    </div>
  );
}
export default Profile;